// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { xScreen } from "@guestsupply/XDL/Utilities";
import { logoLinksSearchStyles } from "@insite/content-library/Widgets/Header/LogoLinksSearch";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

logoLinksSearchStyles.container = {
    css: css`
        display: flex;
        align-items: center;
    `,
};
logoLinksSearchStyles.logoWrapper = {
    css: css`
        margin-right: 64px;
        ${xScreen("lte", "md")} {
            margin-right: 12px;
        }
    `,
};

logoLinksSearchStyles.searchMenuWrapper = {
    css: css`
        flex-basis: 520px;

        ${xScreen("lte", "sm")} {
            flex-basis: 100%;
        }
    `,
};
